import type { RouteRecordRaw } from 'vue-router';

import TeamListView from '@/company/team/views/TeamListView.vue';
import TeamCreateView from '@/company/team/views/TeamCreateView.vue';
import TeamEditView from '@/company/team/views/TeamEditView.vue';
import TeamDeleteView from '@/company/team/views/TeamDeleteView.vue';
import NavigationRailView from '@/services/router/views/NavigationRailView.vue';
import WrapperView from '@/shared/views/WrapperView.vue';

const routes: RouteRecordRaw[] = [
    {
        path: '/vestigingen',
        name: 'team',
        components: {
            default: WrapperView,
            rail: NavigationRailView,
        },
        redirect: { name: 'team-list' },
        children: [
            {
                path: '',
                name: 'team-list',
                components: {
                    default: TeamListView,
                },
                children: [
                    {
                        path: ':teamId/verwijderen',
                        name: 'team-delete',
                        components: {
                            default: TeamDeleteView,
                        },
                    },
                ],
            },
            {
                path: 'aanmaken',
                name: 'team-create',
                components: {
                    default: TeamCreateView,
                },
            },
            {
                path: ':teamId',
                name: 'team-edit',
                components: {
                    default: TeamEditView,
                },
            },
        ],
        meta: {
            allowedRoles: [
                'company-manager',
            ],
        },
    },
];

export default routes;
